import React, { useEffect, useState } from "react";
// import sr from "moment/locale/sr";
// @ts-ignore
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import "../Table.css";
import { isInclusivelyAfterDay, isInclusivelyBeforeDay } from "../helpers/isInclusively";
import moment from "moment";

const MOBILE_CALENDAR = "(max-width: 991px)";

// minDate - 2021-10-31 !!!!!
const minDate = moment("2023-07-16");
const maxDate = moment();

interface DatePickerProps {
  setDate: any;
  /** Opciono — početni datum (admin Dobitnici). Javni sajt ne šalje → juče. */
  initialDate?: moment.Moment;
}

const DatePicker: React.FC<DatePickerProps> = (props) => {
  const [createdAt, setCreatedAt] = useState<moment.Moment>(
    props.initialDate ? props.initialDate.clone() : moment().subtract(1, "days")
  );
  const [calendarFocused, setCalendarFocused] = useState<boolean>(false);
  const [openUp, setOpenUp] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_CALENDAR).matches
  );

  useEffect(() => {
    const media = window.matchMedia(MOBILE_CALENDAR);
    const apply = () => setOpenUp(media.matches);
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, []);

  const onDateChange = (createdAt: moment.Moment | null) => {
    if (createdAt) {
      setCreatedAt(createdAt);
      props.setDate(createdAt);
    }
  };

  const onFocusChange = ({ focused }: { focused: boolean }) => {
    setCalendarFocused(focused);
  };

  return (
    <div className="date_picker">
      <SingleDatePicker
        date={createdAt}
        onDateChange={onDateChange}
        focused={calendarFocused}
        onFocusChange={onFocusChange}
        numberOfMonths={1}
        isOutsideRange={(day: any) =>
          isInclusivelyBeforeDay(day, minDate) ||
          isInclusivelyAfterDay(day, maxDate)
        }
        hideKeyboardShortcutsPanel={true}
        readOnly={true}
        displayFormat="DD-MM-YYYY"
        openDirection={openUp ? "up" : "down"}
        // locale={sr}
      />
    </div>
  );
};

export default DatePicker;
